var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 9.33333L15.8453 6.35856C15.4172 5.5024 15.2032 5.07431 14.8838 4.76155C14.6015 4.48497 14.2611 4.27463 13.8874 4.14575C13.4649 4 12.9863 4 12.0291 4H6.93268C5.43921 4 4.69247 4 4.12204 4.29065C3.62028 4.54631 3.21233 4.95426 2.95666 5.45603C2.66602 6.02646 2.66602 6.77319 2.66602 8.26667V9.33333M2.66602 9.33333H22.9327C25.1729 9.33333 26.293 9.33333 27.1486 9.76931C27.9013 10.1528 28.5132 10.7647 28.8967 11.5174C29.3327 12.373 29.3327 13.4931 29.3327 15.7333V21.6C29.3327 23.8402 29.3327 24.9603 28.8967 25.816C28.5132 26.5686 27.9013 27.1805 27.1486 27.564C26.293 28 25.1729 28 22.9327 28H9.06602C6.82581 28 5.7057 28 4.85005 27.564C4.09741 27.1805 3.48548 26.5686 3.10199 25.816C2.66602 24.9603 2.66602 23.8402 2.66602 21.6V9.33333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFolder);
export default __webpack_public_path__ + "static/media/project-folder.c7ab66ca21c39c38f17d0dcdc127896d.svg";
export { ForwardRef as ReactComponent };